import {
    BillingProvider,
    DocumentPreviewProvider,
    DossierDocumentsProvider,
    DocumentSignModalProvider,
    DossierDocumentSignProvider,
    DossierPrescriberProvider,
    SelectGreffeModal,
    useDefaultContextActions,
    TypeDocumentsProvider,
    CurrentDossierProvider,
    DocumentSignModalWrapper,
} from '@europrocurement/l2d-modules';
import React from 'react';
import { useParams } from 'react-router';
import { useDumbActionsContext } from '@europrocurement/flexy-components';
import DetailDossierContainer from '../../components/DetailDossierContainer/DetailDossierContainer';

const DetailDossier: React.FunctionComponent = function () {
    const { idDossier } = useParams();

    const { backContextActions } = useDefaultContextActions();
    useDumbActionsContext(backContextActions);
    if (!idDossier) {
        console.warn(`Dossier non trouvé paramètres url:  ${idDossier}`);
        return null;
    }
    return (
        <CurrentDossierProvider
            autoload
            idDossier={idDossier}
        >
            <DocumentSignModalProvider>
                <DossierDocumentSignProvider>
                    <TypeDocumentsProvider autoload>
                        <DossierDocumentsProvider
                            autoload
                            dossierIds={[idDossier] as unknown as string[]}
                        >
                            <BillingProvider origine="B2D">
                                <DocumentPreviewProvider>
                                    <DossierPrescriberProvider>
                                        <DetailDossierContainer />
                                    </DossierPrescriberProvider>
                                    <DocumentSignModalWrapper />
                                </DocumentPreviewProvider>
                            </BillingProvider>
                        </DossierDocumentsProvider>
                    </TypeDocumentsProvider>
                    <SelectGreffeModal />
                </DossierDocumentSignProvider>
            </DocumentSignModalProvider>
        </CurrentDossierProvider>
    );
};

export default DetailDossier;
